import { Stack } from '@mui/material';
import { WhatsApp as WhatsAppIcon } from '@mui/icons-material';
import PageHeader from 'domains/core/components/PageHeader';
import SaveAndExitButton from './SaveAndExitButton';
import { ContentStatus } from 'pages/ContentPage/ContentTable/ContentStatusText/ContentStatusText';

type WhatsAppHeaderSectionProps = {
    isLoading: boolean;
    onSaveAndExit: (status?: ContentStatus) => void;
    content: string;
};

const WhatsAppHeaderSection = ({ isLoading, onSaveAndExit, content }: WhatsAppHeaderSectionProps) => (
    <PageHeader
        icon={<WhatsAppIcon htmlColor="#25D366" fontSize="inherit" />}
        header="whatsapp message"
        headerOthers={
            <Stack direction="row" justifyContent="flex-end" width="100%" alignItems="center">
                <SaveAndExitButton isLoading={isLoading} onSaveAndExit={onSaveAndExit} content={content} />
            </Stack>
        }
    />
);

export default WhatsAppHeaderSection;
